import * as React from 'react';

// import { renderMenuButton } from '@fluentui/react-button';

import { RibbonFlyoutAnchorInternalProps } from '../RibbonFlyoutAnchor';
// import { useRibbonFlyoutAnchor } from './useRibbonFlyoutAnchor';
// import { useRibbonButtonStyles } from '../../RibbonButton/next/useRibbonButtonStyles';

/**
 * Define a styled `AppFlyoutAnchor` using the `useAppFlyoutAnchor` hook.
 */
export const RibbonFlyoutAnchor = React.memo(
  // Task 5348034: Upgrade FlyoutAnchor/SplitButton to latest converged version
  React.forwardRef<HTMLElement, RibbonFlyoutAnchorInternalProps>((/*props, ref*/) => {
    // const state = useRibbonFlyoutAnchor(props, ref);

    // useRibbonButtonStyles(state);

    // return renderMenuButton(state);
    return null;
  })
  // shallowCompareWithMenuDefinitionCheck
);

/**
 * Shallow compares previous and new props and aborts the update if it's not required (they match).
 *
 * Due to the way menus are often updated by an external source, we want to make sure
 * that if someone passes a new menu definition that matches the previous one despite being a different object
 * we don't re-render the whole thing unnecessarily.
 */
// function shallowCompareWithMenuDefinitionCheck(
//   prevProps: RibbonFlyoutAnchorInternalProps,
//   nextProps: RibbonFlyoutAnchorInternalProps
// ) {
//   if (Object.keys(prevProps).length !== Object.keys(nextProps).length) {
//     return false;
//   }
//   const differingProps = Object.keys(prevProps).filter((key: keyof RibbonFlyoutAnchorInternalProps) => {
//     if (!nextProps.hasOwnProperty(key)) {
//       return true;
//     }
//     const areUnequalValues = prevProps[key] !== nextProps[key];
//     if ((areUnequalValues && key === 'deferredMenuDefinition') || key === 'menuDefinition') {
//       // Deep compare
//       return JSON.stringify(prevProps[key]) !== JSON.stringify(nextProps[key]);
//     }
//     return areUnequalValues;
//   });
//   return differingProps.length === 0;
// }

RibbonFlyoutAnchor.displayName = 'next/RibbonFlyoutAnchor';
